<template>
<div>
 
  <tyc :tqobj='tqobj'></tyc>
  <div class="m_context">
      <el-row :gutter="20" style="margin-bottom: 20px;">
      <el-col :span="3" style="padding-left: 24px;">
      <el-button type="primary" @click="add" style="width:100%" >{{$t('lin_global.xzwl')}}</el-button>

        </el-col>
      </el-row>
  		<el-table  id="tp" @row-click="linkDetail" :data="tableData2" @sort-change="sortChange" border style="margin-bottom: 20px;">
			<el-table-column sortable="custom" prop="controlName" :label="$t('lin_global.risk_name')" width="300"> 

			<!-- </el-table-column>
			<el-table-column prop="messageName" :label="$t('lin_global.risk_type')" width="150"> -->

			</el-table-column>
			<!-- <el-table-column prop="" label="经纬度" width="">

			</el-table-column> -->
			<el-table-column prop="radius" :label="$t('lin_global.risk_radius')" width="130">

			</el-table-column>
			<el-table-column :formatter="cityFormat" :label="$t('lin_global.risk_city')" width="150">

			</el-table-column>
			<el-table-column prop="controlDesc" :label="$t('lin_global.risk_desc')">

			</el-table-column>
      <el-table-column sortable="custom" prop="createTime" :label="$t('app_addtime')">

			</el-table-column>
      <el-table-column
        align='center'
        :label="$t('lin_global.ope')"
        width="105">
        <template slot-scope="scope">
          <!-- <el-button @click.stop="editRow(scope.row.id)" type="text">{{$t('lin_btn.edit')}}</el-button> -->
          <el-tooltip class="item" effect="dark" :content="$t('lin_btn.edit')" placement="top">
            <el-button type='text' @click.stop="editRow(scope.row.id)"><i class="fa fa-pencil" style=""></i></el-button>
          </el-tooltip>


          

          <!-- <el-button @click.stop="binderRow(scope.row.id)" type="text">{{$t('lin_btn.bind')}}</el-button> -->
          <el-tooltip class="item" effect="dark" :content="$t('lin_btn.bind')" placement="top">
            <el-button type='text' @click.stop="binderRow(scope.row.id)"><i class="fa fa-chain" style=""></i></el-button>
          </el-tooltip>

            <!-- <el-button @click.stop="deleteRow(scope.row.id)" type="text">{{$t('lin_btn.delete')}}</el-button> -->
          <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
            <el-button type='text' @click.stop="deleteRow(scope.row.id)"><i class="fa fa-trash" style="color:#FF4949"></i></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
		</el-table>
		<div class="page_content" v-if="totalRecords > 0">
		  <el-pagination style='float:right;'
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    :current-page="currentPage"
		    :page-sizes="[10,50,100]"
		    :page-size="pageSize"
		    layout="total, sizes, prev, pager, next, jumper"
		    :total="totalRecords">
		  </el-pagination>
		</div>
  </div>

		<el-dialog class='gDia'  :title="$t('lin_global.xzwl')" v-model="dialogFormVisible">
			<el-form :model="form" label-width="12.5%" :rules='rules'>


				<el-form-item :label="$t('lin_global.name')" prop='name'>
					<el-input v-model="form.controllerName" style=""></el-input>
				</el-form-item>


				<el-form-item :label="$t('lin_global.risk_desc')" prop='name' >
					<el-input type="textarea" v-model="form.controllerDesc" style=""></el-input>
				</el-form-item>
				<!-- <el-form-item :label="$t('lin_global.risk_type')">
                <el-select v-model="form.messageId" filterable clearable :placeholder="$t('lin_global.wxzyjlx')">
                       <el-option v-for="item in areaList" :label="item.informname" :value="item.id">
                       </el-option>
                    </el-select>
        </el-form-item> -->

        <el-form-item :label="$t('lin_global.wllx')" style='background:white' prop='name'>
				    <el-radio-group v-model="form.controlType" @change="change">
				      <el-radio label="0">{{$t('lin_global.jwd')}}</el-radio>
				      <el-radio label="1">{{$t('lin_global.city')}}</el-radio>
				    </el-radio-group>
            <el-checkbox @change='cbChange' v-show='form.controlType == 1' v-model="isProv">{{$t('app_onlyprov')}}</el-checkbox>
				</el-form-item>

				<el-form-item prop='name' v-if="ifshow" :label="$t('lin_global.risk_radius')">
					<el-input v-model="radius" style="">
            <template slot="append">{{$t('lin_global.danweikm')}}</template>
          </el-input>
         <!-- {{$t('lin_global.danweikm')}}-->
					<div>{{$t('lin_global.weilanshuoming')}}</div>
				</el-form-item>

				<el-form-item prop='name' v-if="!ifshow" :label="$t('lin_global.cityName')">
					<!--<el-input v-model="citys" style="width:80%"></el-input>-->
          <el-cascader
            v-if='!isProv'
            ref='cas1'
            expand-trigger="click"
            :options="options"
            v-model="sel"
            @change = "selEvent"
            :show-all-levels="false"
          ></el-cascader>
          <el-select v-else v-model="selVl" :placeholder="$t('app_select')">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

				</el-form-item>

				<el-form-item>
		          <el-button @click="onCancel">{{$t('lin_btn.cancel')}}</el-button>
		          <el-button type="primary" @click="submit">{{$t('lin_btn.submit')}}</el-button>
		        </el-form-item>
			</el-form>
		</el-dialog>
  <el-dialog class='gDia' :title="$t('lin_global.bjwl')" v-model="dialogFormVisible2">
    <el-form :model="form2" label-width="100px" :rules="rules">
      <el-form-item :label="$t('lin_global.name')" prop='name'>
        <el-input v-model="form2.controllerName" style="width:80%"></el-input>
      </el-form-item>
      <el-form-item :label="$t('lin_global.risk_desc')" prop='name'>
        <el-input type="textarea" v-model="form2.controllerDesc" style="width:80%"></el-input>
      </el-form-item>
      <!-- <el-form-item :label="$t('lin_global.risk_type')">
        <el-select v-model="form2.messageId" filterable clearable :placeholder="$t('lin_global.wxzyjlx')">
          <el-option v-for="item in areaList" :label="item.informname" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item :label="$t('lin_global.wllx')" style='background:none;' prop='name'>
        <el-radio-group v-model="form2.controlType" @change="change2">
          <el-radio label="0">{{$t('lin_global.jwd')}}</el-radio>
          <el-radio label="1">{{$t('lin_global.city')}}</el-radio>
        </el-radio-group>
        <el-checkbox @change="cbChange1" v-show='form2.controlType == 1' v-model="isProv">{{$t('app_onlyprov')}}</el-checkbox>
      </el-form-item>
      <el-form-item v-if="ifshow2" :label="$t('lin_global.risk_radius')" prop='name'>
        <el-input v-model="radius2" style="width:80%">
          <template slot="append">{{$t('lin_global.danweikm')}}</template>
        </el-input>

        <div>{{$t('lin_global.weilanshuoming')}}</div>
      </el-form-item>
      <el-form-item prop='name' v-if="!ifshow2" :label="$t('lin_global.cityName')">
       <!-- <el-input v-model="citys2" style="width:80%"></el-input>-->
        <el-cascader
          ref='cas2'
          v-if='!isProv'
          expand-trigger="click"
          :options="options2"
          v-model="sel2"
          @change = "selEvent2"
          :show-all-levels="false"
        ></el-cascader>
        <el-select v-else v-model="selVl2" :placeholder="$t('app_select')">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="onCancel2">{{$t('lin_btn.cancel')}}</el-button>
        <el-button type="primary" @click="submit2">{{$t('lin_btn.submit')}}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>

  <el-dialog class='gDia' :title="$t('lin_global.bdsb')" v-model="dialogTopMgVisible" @close='closeBindAlert'>
    <el-row :gutter="20" style="margin-bottom: 20px;">
      <el-col :span="6">

        <!-- <el-select v-model="value1" @change="statusChange" :placeholder="$t('lin_global.pselect')">
          <el-option v-for="item in areaList1" :label="item.mechanismname" :value="item.mechanismid">
          </el-option>
        </el-select> -->
        <div style='margin-left:16px;'><MechanismSelector style='width:100%;' :data="mechanismData"></MechanismSelector></div>

      </el-col>
      <el-col :span="6">
        <el-select v-model="stvl" @change="statusChange" :placeholder="$t('lin_global.pselect')">
          <el-option v-for="item in sttyps" :key="item.vl" :label="item.lb" :value="item.vl">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-input
          :placeholder="$t('lin_global.label_no')"
          icon="search"
          v-model="input1"
          :on-icon-click="handleIconClick"
          @keyup.enter.native="focusEvent(handleIconClick)">
        </el-input>
      </el-col>

      <el-col :span="6">
        <el-button type="primary" @click="batchBindRow" style="">{{$t('lin_btn.bindAll')}}</el-button>
      </el-col>

      
    </el-row>

    <el-table
      :data="arrdata1"
      border
      style="100%"
      @selection-change="handleSelectionChange1">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        prop="terminalName"
        :label="$t('lin_global.label_name')"
        width="150">
      </el-table-column>
      <el-table-column
        prop="terminalNo"
        :label="$t('lin_global.label_no')"
        width="150">
      </el-table-column>
      <el-table-column
        :label="$t('lin_global.status')"
        width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.terminalStatus == 1 " type="success" size="mini">{{$t('lin_global.online')}}</el-tag>
          <el-tag v-if="scope.row.terminalStatus == 2 " type="danger" size="mini">{{$t('lin_global.offline')}}</el-tag>
          <el-tag v-if="scope.row.terminalStatus == 0 " type="gray" size="mini">{{$t('lin_global.new_add')}}</el-tag>
          <el-tag v-if="scope.row.terminalStatus == 3 " type="warning" size="mini">{{$t('app_sleep')}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="mechName"
        :label="$t('lin_global.label_areaid')"
        width="150">
      </el-table-column>
      <el-table-column
        :label="$t('lin_global.ope')">
        <template slot-scope="scope">
          
          <el-tooltip class="item" effect="dark" :content="$t('lin_btn.bind')" placement="top">
            <el-button type='text'  @click.stop="bindRow(scope.row.terminalId)"><i class="fa fa-chain" style=""></i></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    
    <div style="margin-top: 20px;float: right;margin-bottom: 20px;">
      <el-pagination
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="currentPage1"
        :page-sizes="[10,50,100]"
        :page-size="pageSize1"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords1">
      </el-pagination>
    </div>
  </el-dialog>
</div>
</template>

<script>
	import axios from 'axios'
	import {baseurl,focusEvent} from '../../api/url'
  import city from '../city.js'
  // 
  import tyc from "@/components/global/tyc.vue"
  import {chengshi} from '../citys.js'
  import { setTimeout } from 'timers';
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
	export default{
    components: {
      tyc,MechanismSelector
    },
		data () {
      var _this = this
			return{
        mechanismData: {
          callback (value) {
			      _this.value1 = value            
            _this.statusChange()
          }
        },
        stvl: '',
        sttyps: [],
        tqobj: '',
        rules: {
          name: [
            { required: true, message: ' ', trigger: 'blur' }
          ]
        },
        isProv: false,
        orderType: '',
        orderName: '',
        sel:[],
        sel2:[],
        selVl: '',
        selVl2: '',
        options: JSON.parse(JSON.stringify(city)),
        options2: JSON.parse(JSON.stringify(city)), //
        focusEvent: focusEvent,
        riskId:'',
				radius:'',
				citys:'',
        radius2:'',
        citys2:'',
        input1:'',
        value1: '',
        areaList1: [],
        ifshow:true,
        distributorId: '',
        ifshow2:true,
				dialogFormVisible:false,
        dialogFormVisible2:false,
        dialogTopMgVisible:false,
				currentPage: 1,
				pageSize: 10,
				totalRecords: 0,
        currentPage1: 1,
        pageSize1: 10,
        totalRecords1: 0,
				areaList:[],
        arrdata1:[],
				tableData2:[],
				form:{
					controllerName:'',
					controllerDesc:'',
					messageId:'',
					controlType:'0'
				},
        form2:{
          controllerName:'',
          controllerDesc:'',
          messageId:'',
          controlType:''
        },
				params:{},
        multipleSelection1: [],
        
			}
    },
    mounted () {
      this.tqobj = {
        keys: ['terminalTypes'],
        callback: data => {
          console.log('ddd', data[0])
          this.sttyps = data[0]
        }
      }
    },
    created () {
      
      this.distributorId = localStorage.mechanismId
			this.getData(1,'','');
			this.getAd();
      this.getData1(1,'','');
      // this.getAd1();

		},
		methods:{
      closeBindAlert () {
        var _this = this
        this.mechanismData = {
          callback (value) {
			      _this.value1 = value            
            _this.statusChange()
          }
        }
        this.value1 = '' 
        this.stvl = ''
        this.input1 = ''
        this.dialogTopMgVisible = false
      },
      cbChange () {
        
        // this.form.controlType = '0'
        // this.options = JSON.parse(JSON.stringify(city))
        // var _this = this
        // setTimeout(()=> {
        //   _this.form.controlType = '1'
        // }, 22)
      
      },
      cbChange1 () {

        // this.form2.controlType = '0'
        // this.options2 = JSON.parse(JSON.stringify(city))
        // var _this = this
        // setTimeout(()=> {
        //   _this.form2.controlType = '1'
        // }, 22)

      },
      sortChange (vl) {
        
        switch (vl.prop) {
          case 'controlName':
            this.orderName = '1'
            break
          case 'createTime':
            this.orderName = '2'
            break
        }
        this.orderType = vl.order == 'descending'? 'desc':'asc'
        this.getData(this.currentPage,'','')
      },
      cityFormat:function(row){
          if(row.city){
            var value = row.city.split(',')[0];
            return value
          }

      },
      hasValue:function(result,v,name){
        if (!v[name] || v[name] === "") {
          return true;
        }
        return result.some((re) => v[name] === re);
      },
      selEvent:function(val){
        
        
        
        return
          var result = val.toString().split(',');
          var arr = this.options.filter(v => {
            if(this.hasValue(result,v,"value")){
              if (v.children && v.children.length > 0) {
                v.children = v.children.filter(child => {
                  if (this.hasValue(result,child,"value")) {
                    return child
                  }
                  return false;
                });
                return v
              } else {
                return v
              }
            }
          });
        // this.options = this.zicity;
        if(arr[0].value === "110000" || arr[0].value === "120000" || arr[0].value === "310000" || arr[0].value === "500000"){
          this.citys = arr[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
        }else{
          this.citys = arr[0].label + arr[0].children[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
        }
          //alert(this.citys);
      },
      selEvent2:function(val){
       
        return
        var result = val.toString().split(',');
        var arr = this.options2.filter(v => {
          if(this.hasValue(result,v,"value")){
            if (v.children && v.children.length > 0) {
              v.children = v.children.filter(child => {
                if (this.hasValue(result,child,"value")) {
                  return child
                }
                return false;
              });
              return v
            } else {
              return v
            }
          }
        })

        // this.options2 = this.cityzi;
        if(arr[0].value === "110000" || arr[0].value === "120000" || arr[0].value === "310000" || arr[0].value === "500000"){
          this.citys2 = arr[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
        }else{
          this.citys2 = arr[0].label + arr[0].children[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
        }
        //alert(this.citys);
      },
      getAd1:function(){
        // var params = {page:1,rows:10000};
        // axios.post(`${baseurl}/mechanism/list.do`,params).then(res=>{
        //   //console.log(res.data);
        //   var obj={
        //     'mechanismname':this.$t('lin_global.all_mechanism'),
        //     'mechanismid':''
        //   }
        //   this.areaList1 = res.data.data;
        //   if(this.areaList1){
        //     this.areaList1.unshift(obj)
        //   }
        // })
      },
      getData1(page,no,areaid){

        this.currentPage1 = page;
        var stvl = this.stvl?this.stvl:''
        var params = {
          page:page,
          rows:this.pageSize1,
          areaid:areaid,
          terminal_no:no,
          terminal_status: stvl,
          terminal_runtime_status:''
        }
        //console.log("打印传出参数");
        //console.log(params);
        axios.post(`${baseurl}/terminal/list.do`, params).then(res=> {
          //console.log("打印返回列表");
          //console.log(res.data);
          this.arrdata1 = res.data.data;
          this.totalRecords1 = res.data.total;
        }).catch(function (error) {

        })
      },
      statusChange(){
        this.getData1(1,this.input1,this.value1)
      },
      handleIconClick(){
        this.getData1(1,this.input1,this.value1)
      },
      deleteRow:function(id){
          var params = {"riskId":id}
        this.$confirm(this.$t('lin_global.qdxysccwl'),this.$t('lin_btn.tips'),{
          confirmButtonText: this.$t('lin_btn.confirm'),
          cancelButtonText: this.$t('lin_btn.cancel'),
          type: 'warning'
        }).then(()=>{
          axios.post(`${baseurl}/risk/deleteController.do`,params).then(res=>{
            console.log("打印看看删除返回信息")
            console.log(res.data);
            if(res.data.status == 200){
              this.$message.success(this.$t('lin_global.delete_success'));
              this.getData(1,'','');
            }else{
              this.$message.error(res.data.message)
            }
          })
        }).catch(() => {

        })
      },
      binderRow:function(id){        
        this.riskId = id   
        this.statusChange()
        this.dialogTopMgVisible = true;
      },
      editRow:function(id){
        this.dialogFormVisible2 = true;
        this.riskId = id;
        //this.options2=chengshi;
        
        
        // this.options2 = this.cityzi;
        this.getDetail()
      },
      change2:function(){
        if(this.form2.controlType=='0'){
          this.ifshow2 = true;
        }else{
          this.ifshow2 = false;
        }
      },
      handleSizeChange1: function (val) {
        this.pageSize1 = val
        this.getData1(this.currentPage1,'','')
      },
      handleCurrentChange1: function (val) {
        this.currentPage1 = val
        this.getData1(this.currentPage1,'',this.value1) // value1
      },
      handleSelectionChange1(val){
        this.multipleSelection1 = val
      },
      bindRqs (id, isForce) {
        var params = {riskId:this.riskId,terminalId:id,status:'0', force: isForce?'1':'0'}
        axios.post(`${baseurl}/risk/bindingTerminal.do`,params).then(res=>{
          if (res.data.status == '200') {
            this.$message.success(this.$t('lin_global.bdcg'))            
            this.getList()
            this.closeBindAlert()
          } else if (res.data.status == 300) {
            // var _this = this
            this.$showConfirm(
              this.$t("app_tip"),
              res.data.message,
              this.$t("app_sure"),
              this.$t("app_cancel"),
              "warning",
              () => {                
                this.bindRqs(id, true)
              },"")                
          } else  {
            this.$message.error(res.data.message)
          }
        })
      },
      bindRow (id, isForce) {        
        this.$confirm(this.$t('lin_global.sfbdczd'), this.$t('lin_btn.tips'), {
          confirmButtonText: this.$t('lin_btn.confirm'),
          cancelButtonText: this.$t('lin_btn.cancel'),
          type: 'warning'
        }).then(() => {
          this.bindRqs(id)
        })
      },
      batchBindRow () {
        if (this.multipleSelection1.length === 0) {
          this.$message.error(this.$t('lin_global.qxzybddzd'))
          return false
        }else{
          this.$confirm(this.$t('lin_global.sfjxplbd'), this.$t('lin_btn.tips'), {
            confirmButtonText: this.$t('lin_btn.confirm'),
            cancelButtonText: this.$t('lin_btn.cancel'),
            type: 'warning'
          }).then(() => {
            let ids = []

            for (let i = 0; i < this.multipleSelection1.length; i++) {
              ids.push(this.multipleSelection1[i].terminalId)
            }
            let rq = ids.join(',');
            this.bindRqs(rq)
            // var params = {riskId:this.riskId,terminalId:rq,status:'0'};
            // axios.post(`${baseurl}/risk/bindingTerminal.do`,params).then(res=>{
            //   //console.log("打印类型")
            //   //console.log(res.data.data)
            //   if (res.data.status == '200') {
            //     this.$message.success(this.$t('lin_global.bdcg'))
            //     //this.getList(1);
            //     this.dialogTopMgVisible = false;
            //   } else {
            //     this.$message.error(res.data.message)
            //   }
            // })
          }).catch(() => {

          })
        }

      },
      submit2:function(){
        this.params = {};

        if (!this.form2.controllerName) {
          this.$message.error(this.$t('app_inputName'))
          return
        }
        
        if (!this.form2.controllerDesc) {
          this.$message.error(this.$t('app_inputIntrol'))
          return
        }
        
        if(this.form2.controlType=='0'){
          this.params.id = this.riskId;
          this.params.radius = this.radius2;
          this.params.controllerName = this.form2.controllerName;
          this.params.controllerDesc = this.form2.controllerDesc;
          this.params.messageId = this.form2.messageId;
          this.params.controlType = this.form2.controlType;

          if (isNaN(Number(this.radius2)) || Number(this.radius2) <= 0.5) {
            this.$message.error(this.$t('app_rdneedmore') + '0.5') 
            return
          }
        }else{
          this.params.id = this.riskId;
          // this.params.city = this.citys2;

          
          var fcode = this.sel2[0]
          var scode = this.sel2.length == 2? this.sel2[1]:''
          var cname = ''
          var tmpsub = []
          if (!this.isProv) {
            //child
            city.forEach(item => {
              if (item.value == fcode) {
                item.children.forEach(sitem => {
                  if (sitem.value == scode) {
                    //// 
                    cname = sitem.province==sitem.label? sitem.label : sitem.province+sitem.label
                    return
                  }
                })
              }
            })
          } else {
            //p
            city.forEach(item => {
              if (item.value == this.selVl2) {
                cname = item.label
                return
              }
            })
          }
          this.params.city = cname + ',' + (this.isProv? this.selVl2:this.sel2.toString());
          

          this.params.controllerName = this.form2.controllerName;
          this.params.controllerDesc = this.form2.controllerDesc;
          this.params.messageId = this.form2.messageId;
          this.params.controlType = this.form2.controlType;

        }
       
       
        if (this.params.city==',' && this.form2.controlType==1) {
          this.$message(this.$t('lin_global.risk_city'))
          return 
        }
        var params = this.params
        params.controlType = this.isProv? '2':this.form2.controlType
        axios.post(`${baseurl}/risk/editRisk.do`,params).then(res=>{
          //console.log("打印看看编辑返回信息")
          //console.log(res.data);
          if(res.data.status == 200){
            
            this.citys2 = ''
            this.params.city = ''

            this.dialogFormVisible2 = false;
            this.$message.success(res.data.message);
            this.getData(1,'','');
          }else{
            this.dialogFormVisible2 = false;
            this.$message.error(res.data.message)
          }
        })
      },
      getDetail:function(){
        var params = {riskId:this.riskId};
        this.sel2 = [];
        axios.post(`${baseurl}/risk/getByIdRisk.do`,params).then(res=>{
          //console.log("打印围栏详情")
          //console.log(res.data);
          this.form2.controllerName = res.data.data.controlName;
          this.form2.controllerDesc = res.data.data.controlDesc;
          this.form2.messageId = res.data.data.messageid;
          if(res.data.data.controlType == '0'){
            this.ifShow2 = true;
            this.ifshow2 = true;
            this.form2.controlType = '0';
            this.radius2 = res.data.data.radius;
          }else{
            this.ifShow2 = false;
            this.ifshow2 = false;
            this.form2.controlType = '1'
            
            // this.citys2 = res.data.data.city;
            var arr = res.data.data.city.split(',');
            arr.shift()
            if (arr.length == 2) {
              this.sel2 = arr
              this.isProv = false
            } else {
              this.selVl2 = arr[0]
              this.isProv = true
            }
            
          }
        })
      },
			submit:function(){
        this.params = {};
        
        // if (!this.form.messageId) {
        //   this.$message.error(this.$t('lin_global.qxzlx'))
        //   return
        // }
    

        if (!this.form.controllerName) {
          this.$message.error(this.$t('app_inputName'))
          return
        }
        
        if (!this.form.controllerDesc) {
          this.$message.error(this.$t('app_inputIntrol'))
          return
        }


        if(this.form.controlType=='0'){
          
					this.params.radius = this.radius;
					this.params.controllerName = this.form.controllerName;
					this.params.controllerDesc = this.form.controllerDesc;
					this.params.messageId = this.form.messageId;
          this.params.controlType = this.form.controlType;
          
          
          if (isNaN(Number(this.radius)) || Number(this.radius) <= 0.5) {
          this.$message.error(this.$t('app_rdneedmore') + '0.5')
          return

        }
          

				}else{

          if ((this.sel.length == 0 && !this.isProv) || 
          (!this.selVl && this.isProv)) {
            this.$message.error(this.$t('lin_global.risk_city'))
            return
          }
          
          
          var fcode = this.sel[0]
          var scode = this.sel.length == 2? this.sel[1]:''
          var cname = ''
          var tmpsub = []
          if (!this.isProv) {
            //child
            city.forEach(item => {
              if (item.value == fcode) {
                item.children.forEach(sitem => {
                  if (sitem.value == scode) {
                    //// 
                    cname = sitem.province==sitem.label? sitem.label : sitem.province+sitem.label
                    return
                  }
                })
              }
            })
          } else {
            //p
            city.forEach(item => {
              if (item.value == this.selVl) {
                cname = item.label
                return
              }
            })
          }
          this.params.city = cname + ',' + (this.isProv? this.selVl : this.sel.toString());
          
          
					this.params.controllerName = this.form.controllerName;
					this.params.controllerDesc = this.form.controllerDesc;
					this.params.messageId = this.form.messageId;
          this.params.controlType = this.form.controlType;
				}
      
      
        
        var params = this.params;
        params.distributorId = this.distributorId
        params.controlType = this.isProv? '2':this.form.controlType
        
				axios.post(`${baseurl}/risk/addRisk.do`,params).then(res=>{
            //console.log("打印看看登陆信息")
            //console.log(res.data);
            this.cleanForm()
            if(res.data.status == 200){
              this.dialogFormVisible = false;
              this.$message.success(res.data.message);
              this.getData(1,'','');
            }else{
              this.dialogFormVisible = false;
              this.$message.error(res.data.message)
            }
        })
			},
			onCancel:function(){
        this.dialogFormVisible = false;
        this.cleanForm()
      },
      cleanForm () {
        this.form.controllerName = ''
				this.form.controllerDesc = ''
        this.form.messageId = ''
        this.sel = []
        this.selVl = ''
        this.radius = ''
				this.form.controlType = '0'
      },
      cleanForm2 () {
        this.form2.controllerName = ''
				this.form2.controllerDesc = ''
        this.form2.messageId = ''
        this.sel2 = []
        this.selVl2 = ''
        this.radius = ''
				this.form2.controlType = '0'
      },
      onCancel2:function(){
        this.dialogFormVisible2 = false;
        this.cleanForm2()
      },
			change:function(){
				if(this.form.controlType=='0'){
					this.ifshow = true;
				}else{
					this.ifshow = false;
				}
			},
			getAd:function(){
		    	axios.post(`${baseurl}/risk/getMessageInform.do`,{}).then(res=>{
		    		//console.log("打印类型")
		    		//console.log(res.data.data)
		    		this.areaList = res.data.data;
		    	})
		    },
			add:function(){
			    this.sel = [];
				this.dialogFormVisible = true;
			},
			linkDetail:function(row){
				//console.log(row.id)
				this.$router.push({ path: '/rail/'+row.id+'/detail' })
			},
			handleSizeChange: function (val) {
		        this.pageSize = val
		        this.getData(this.currentPage,'','')
		    },
		    handleCurrentChange: function (val) {
		        this.currentPage = val
		        this.getData(this.currentPage,'','')
		    },
			getData ( page,no,areaid){
				this.currentPage = page;
				var params2 = {orderName: this.orderName, orderType:  this.orderType,page:page,rows:this.pageSize,controllerName:'',messageId:'',terminalId:'', distributorId: this.distributorId};
				//console.log("打印传餐");
				//console.log(params2)
				axios.post(`${baseurl}/risk/listController.do`,params2).then(res=>{
					//console.log("打印返回列表2");
					//console.log(res.data);
					this.tableData2 = res.data.data;
					this.totalRecords = res.data.total;
				})
			}
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// rail.vue?22cfa33c